import { render, staticRenderFns } from "./btnAdminCardEditNew.vue?vue&type=template&id=676b8734&scoped=true"
import script from "./btnAdminCardEditNew.vue?vue&type=script&lang=js"
export * from "./btnAdminCardEditNew.vue?vue&type=script&lang=js"
import style0 from "./btnAdminCardEditNew.vue?vue&type=style&index=0&id=676b8734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676b8734",
  null
  
)

export default component.exports